import Collection from '@/components/Collection'
import CreateTransaction from '@/pages/transaction/CreateForm'
import access from "../access";

export default {

  'transaction.collection': {
    path: '/admin/transactions',
    name: 'transaction.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listCreditTransactions",
      entity: "transaction",
      cols: [
        { label: "ID", field: "id", sort: "id" },
        { label: "Subject", field: "subject" },
        { label: "Operation", field: "operation" },
        { label: "Value", field: "credit_value", sort: "credit_value" },
        { label: "Registrar", field: "registrar_name", sort: "registrar" },
        { label: "Date", field: "timestamp", sort: "timestamp", date: "date" },
        { label: "Note", field: "note" }
      ]
    },
    meta: {
      access: access.admin,
      title: "Credit transaction list",
      side_menu: { label: "Transactions",  icon: "coin-dollar" },
      local_actions: [
        { name: "transaction.create", label: "Create transaction", color: "success", icon: "plus" }
      ]
    },
  },

  'transaction.create': {
    path: '/admin/transactions/create',
    name: 'transaction.create',
    component: CreateTransaction,
    meta: {
      access: access.admin,
      title: "Create new credit transaction"
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/transaction.js